<template>
  <NotificationText v-bind="$props">
    <template #primary>
      Warte auf Annahme von <i>{{peerName}}</i>
    </template>
    <template #secondary>
      {{filesLength}} {{files}}
      <template v-if="notification.data.description">
        ({{notification.data.description}})
      </template>
    </template>
    <template #detail-content>
      <PeerFiles
        :files="notification.data.files"
        :description="notification.data.description"
      />
    </template>
    <template #actions>
      <v-btn text small color="red" @click="reject">Abbrechen</v-btn>
    </template>
  </NotificationText>
</template>

<script>
  import PeerNotificationTextMixin from './peer-notification-text-mixin';


  export default {
    name: 'PeerFilesPending',

    mixins: [
      PeerNotificationTextMixin
    ]
  };
</script>
